import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ClientSubscriptionsPage } from './ClientSubscriptionsPage'
import { useAuth } from '../../modules/auth';
import { WhiteLabelProvider } from '../subscriptions/components/WhiteLabelProvider';

const ClientSubscriptionsWrapper: React.FC = () => {
  const { currentUser } = useAuth();
  const company = currentUser?.companies?.[0] || null;

  return (
    <WhiteLabelProvider company={company}>
      <PageTitle breadcrumbs={[]}>Minhas Assinaturas</PageTitle>
      <ClientSubscriptionsPage />
    </WhiteLabelProvider>
  )
}

export default ClientSubscriptionsWrapper
